// Modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { JwtInterceptor } from './common/guards/jwt.interceptor';

// Components
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { IndustriesComponent } from './components/home/industries/industries.component';
import { AccountComponent } from './components/account/account.component';
import { AccountIndustriesComponent } from './components/account/account-industries/account-industries.component';
import { AccountCaseComponent } from './components/account/account-case/account-case.component';
import { LoginComponent } from './components/login/login.component';
import { ButtonComponent } from './components/account/account-industries/button/button.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ErrorComponent } from './components/error/error.component';
import { LoginPageComponent } from './components/home/login-page/login-page.component';
import { RequestAccessComponent } from './components/home/request-access/request-access.component';
import { ConfirmationComponent } from './components/home/confirmation/confirmation.component';

import { environment } from '../environments/environment';

// Services
import { CookieService } from 'ngx-cookie-service';
import { SafeURLPipe } from './common/services/vimeo.service';
import { SafeHTMLPipe } from './common/services/html.service';

// Directives
import { ExternalLinkDirective } from './directives/external-link.directive';
import { TemplateVariableDirective } from './directives/template-variable.directive';
import { BtnVariableDirectiveDirective } from './directives/btn-variable-directive.directive';
import { ErrorInterceptor } from './common/guards/error.interceptor';
import { FailedComponent } from './components/messages/failed/failed.component';
import { SuccessComponent } from './components/messages/success/success.component';
import { ModalComponent } from './components/modal/modal.component';
import { AccountExampleComponent } from './components/account/account-example/account-example.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    IndustriesComponent,
    AccountComponent,
    AccountIndustriesComponent,
    AccountCaseComponent,
    SafeURLPipe,
    SafeHTMLPipe,
    LoginComponent,
    ButtonComponent,
    SpinnerComponent,
    ExternalLinkDirective,
    ErrorComponent,
    TemplateVariableDirective,
    BtnVariableDirectiveDirective,
    RequestAccessComponent,
    LoginPageComponent,
    ConfirmationComponent,
    FailedComponent,
    SuccessComponent,
    ModalComponent,
    AccountExampleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    FontAwesomeModule,
    MatSnackBarModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    RecaptchaModule,
    ScrollToModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.googleSiteKey,
      } as RecaptchaSettings,
    },
    CookieService
],
  bootstrap: [AppComponent]
})

export class AppModule { }

